import React, { useEffect, useState } from 'react'
import _ from "lodash"
import XLSX from 'xlsx'
import moment from "moment"
import { Button } from "reactstrap"
import { useTranslation } from 'react-i18next'

import Form from 'main_views/components/Form/form_v2'
import Modal from "main_views/components/Modal"
import i18n from 'utils/translation/i18n'
import { setFieldValue } from 'main_views/form/formHandler'
import { errorToast } from 'main_views/components/toast'

function ExportTable(props) {

   let { t } = useTranslation()

   let { title, header, body, selectDateRangeBeforeExport, dataQuery, dataHandler, exportData } = props

   let [form, setForm] = useState(formFields)
   let [showDateModal, setShowDateModal] = useState(false)
   let [dataIsLoading, setDataIsLoading] = useState(false)

   useEffect(() => {

      return () => setDataIsLoading(false)
   }, [])

   let setChanges = (stateName, value, className) => {
      setFieldValue(form, stateName, value, className)
      setForm({ ...form }) // to re-render the form 
   }

   let onExport = () => {
      if (selectDateRangeBeforeExport) {
         setShowDateModal(true)
      } else {
         toXLSX(title, header, body)
      }
   }

   let exportByDate = async () => {

      let { fromDate, toDate } = form

      // check the values
      if (_.isEmpty(fromDate.value) || _.isEmpty(toDate.value))
         return errorToast('Please Set a Date')

      let fromDate_asMoment = getTimeAsMoment(fromDate.value).startOf('date'),
         toDate_asMoment = getTimeAsMoment(toDate.value).endOf('date')

      // check the range
      if (fromDate_asMoment.isAfter(toDate_asMoment))
         return errorToast('invalid date range')

      try {

         let tickets

         if (exportData) { // TODO: remove this condition after fix history and my Tasks pages

            // filter the data by open date
            tickets = _.filter(exportData, b =>
               getTimeAsMoment(b.openedAt).isBetween(fromDate_asMoment, toDate_asMoment, undefined, '[]')
            )

         } else {

            // make a firebase query
            setDataIsLoading(true)

            tickets = await getTickets(dataQuery, fromDate_asMoment, toDate_asMoment)

            // no data
            if (_.isEmpty(tickets)) {
               return errorToast('There are No Tickets at the selected date range')
            }

            // re-handel the data
            tickets = await dataHandler(tickets)

         }

         // export the data
         toXLSX(title, header, tickets, [{
            [t('from_date')]: fromDate_asMoment.format('DD/MM/YYYY hh:mm:ss a'),
            [t('to_date')]: toDate_asMoment.format('DD/MM/YYYY hh:mm:ss a')
         }])

      } catch (error) {
         console.log("ExportTable -> error", error)
         errorToast(t('something_wrong'))
         setDataIsLoading(false)

      } finally {
         setDataIsLoading(false)
      }

   }

   let getTimeAsMoment = (time) => moment.unix(time.seconds)

   return (
      <>
         <Button color="info" onClick={onExport}>
            <span className="btn-label"><i className="fa fa-file-excel-o fa-lg" />{`\t\t Export as EXCEL`}</span>
         </Button>

         {/* Select a date range modal */}
         <Modal
            isOpen={showDateModal}
            toggle={() => setShowDateModal(false)}
            title={t('select_date_to_export')}
            subTitle={title}
            hasFooter={true}
            onSave={exportByDate}
            saveText={t(dataIsLoading ? 'loading' : 'export')}
         >
            <div style={{ minHeight: '50vh', display: 'grid' }}>
               <Form
                  inputs={form}
                  onChange={setChanges}
               />
            </div>
         </Modal>
      </>
   )
}

export default ExportTable

let formFields = {
   fromDate: {
      name: i18n.t('from_date'),
      required: true,
      stateName: 'fromDate',
      type: 'TextInputDate',
      value: { seconds: moment().startOf('month').unix() } // start of month
   },
   toDate: {
      name: i18n.t('to_date'),
      required: true,
      stateName: 'toDate',
      type: 'TextInputDate',
      value: { seconds: moment().unix() } // current time
   },
}

/**
 * get tickets by dates range a spcific query fields
 *
 * @param {Object|Array} dataQuery
 * @param {Moment} fromDate
 * @param {Moment} toDate
 */
export async function getTickets(dataQuery, fromDate, toDate) {

   let db = window.firebaseFirestore
   let ticketsRef = db.collection('tickets')

   if (dataQuery) {
      if (Array.isArray(dataQuery)) { // many query

         _.forEach(dataQuery, q => ticketsRef = ticketsRef.where(q.field, '==', q.value))

      } else {

         ticketsRef = ticketsRef.where(dataQuery.field, '==', dataQuery.value)
      }
   }

   // add the date range
   ticketsRef = ticketsRef
      .where('openedAt', '>=', fromDate.toDate())
      .where('openedAt', '<=', toDate.toDate())

   let ticketsSnapshot = await ticketsRef.get()
   let tickets = []

   ticketsSnapshot.forEach((doc) => tickets.push(doc.data()))

   return tickets

}

/**
 * convert the data to XLSX file format and load the file
 *
 * @param {array} header
 * @param {array} body
 */
function toXLSX(fileName, header, body, extra) {

   let sheetData = []

   // handel the body data
   _.forEach(body, row => {

      if (_.has(row, 'openedAt')) // only for tickets
         row.date = !_.isEmpty(row.approvedBy) ? _.last(_.values(row.approvedBy)).date : moment(row.openedAt.toDate())

      // handel each col (to display it in order)
      let rowData = {}
      _.forEach(header, col => {

         if (["button", "buttons", "dropDownMenu", "editAndDeleteButtons"].includes(col.type)) return

         let value = _.get(row, col.accessor)

         if (!_.isEmpty(value)) {

            switch (col.type) {

               case "priorityTxt":
                  value = i18n.t(value)
                  break;

               case "firestoreTime":
                  value = moment(value.toDate()).format('DD/MM/YYYY')
                  break;

               case "firestoreDateAndTime":
                  value = moment(value.toDate()).format('DD/MM/YYYY HH:mm')
                  break;

               case "dateAndTime":
                  let { redirects, approvedBy, openedAt } = row
                  approvedBy = _.orderBy({ ...approvedBy, ...redirects }, info => moment(info.date, 'YYYY-MM-DD hh:mm:ss'))

                  let lastAction = _.last(_.values(approvedBy))
                  value = lastAction ? moment(lastAction.date, 'YYYY-MM-DD hh:mm:ss').toDate().toLocaleString() : openedAt.toDate().toLocaleString()
                  break;

            }

         }

         _.set(rowData, col.Header, value ?? '') // set the Col Label with its data

      })

      sheetData.push(rowData)
   })

   // export json to Worksheet of Excel
   var dataWs = XLSX.utils.json_to_sheet(sheetData)

   // make Workbook of Excel
   var wb = XLSX.utils.book_new()

   // add Worksheet to Workbook
   XLSX.utils.book_append_sheet(wb, dataWs, fileName)

   if (!_.isEmpty(extra)) {
      // extra sheet data
      var dataWs2 = XLSX.utils.json_to_sheet(extra)

      // add Worksheet to Workbook
      XLSX.utils.book_append_sheet(wb, dataWs2, i18n.t('selected_duration'))
   }

   // export Excel file
   XLSX.writeFile(wb, `${fileName} in ${moment().format('YYYY-MM-DD')} at ${moment().format('hh:mm:ss')}.xlsx`)

}
